<!-- 
出荷ラベルの親カードを表示する
-->

<template>
  <div>
    <v-card
      elevation="5"
      :class="{
        'card-warning': cardColor == 20,
        'card-error': cardColor == 30,
      }"
      class="ma-4"
    >
      <v-card-title class="custom-card-title">出荷ラベル</v-card-title>
      <v-card-text>
        <v-row v-if="errorMsg" align-content="center">
          <v-col cols="auto" align="left">
            <font color="red" class="custom-card-text">{{ errorMsg }}</font>
          </v-col>
        </v-row>
        <v-row
          align="center"
          v-for="(destinationLabel, index) in destinationLabels"
          :key="destinationLabel.key"
        >
          <v-col>
            <!-- カード -->
            <destination-card-label-child
              :destinationLabel="destinationLabel"
              @on-click-remove="remove(index)"
              @change-destination-label="changeDestinationLabel($event, index)"
              ref="destination_card_label_child"
            ></destination-card-label-child>
          </v-col>
        </v-row>
        <!-- 追加ボタン -->
        <v-row align="center">
          <v-col align="center">
            <v-btn slot="append" icon outlined color="primary" @click="append">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DestinationCardLabelChild from "./append-destination-label-card-base.vue";
const CARD_COLOR_NOMAL = 10;
const CARD_COLOR_WARNING = 20;
const CARD_COLOR_ERROR = 30;

export default {
  name: "destination-card-label-parent",
  components: {
    "destination-card-label-child": DestinationCardLabelChild,
  },
  props: {},
  watch: {},
  computed: {
    /**
     * formDataの入力が不正ならtrueを返す
     */
    hasErrorFormData() {
      for (let i = 0; i < this.destinationLabels.length; i++) {
        if (this.destinationLabels[i].hasErrorFormData) {
          return true;
        }
      }
      return false;
    },
    cardColor: function () {
      // カードがない場合
      if (this.destinationLabels.length == 0) {
        return CARD_COLOR_ERROR;
      }

      let childCardColor = [];
      for (let i = 0; i < this.destinationLabels.length; i++) {
        childCardColor.push(this.destinationLabels[i].cardColor);
      }

      if (childCardColor.includes(CARD_COLOR_ERROR)) {
        // エラーを含む場合
        return CARD_COLOR_ERROR;
      } else if (childCardColor.includes(CARD_COLOR_WARNING)) {
        // 警告を含む場合
        return CARD_COLOR_WARNING;
      } else {
        // エラーも警告も含まない場合
        return CARD_COLOR_NOMAL;
      }
    },
    errorMsg: function () {
      if (this.cardColor == CARD_COLOR_WARNING) {
        return "入力途中です";
      } else {
        return "";
      }
    },
  },
  data() {
    this.temperature = 0;
    this.destinationLabels = [];
    return {
      seaArea: "",
      destinationLabels: [],
      total: 0,
    };
  },
  methods: {
    /**
     * カードを追加する
     */
    append() {
      if (this.destinationLabels.length > 0) {
        // 一番上のカードの値をコピーしてカードを追加する;
        this.setDestinationLabels({
          name: "",
          expirationDate: "",
          temperature: this.destinationLabels[0].temperature,
          seaArea: this.destinationLabels[0].seaArea,
          processingPerson: this.destinationLabels[0].processingPerson,
        });
      } else {
        // 空のカードを追加する
        this.setDestinationLabels({
          name: "",
          expirationDate: "",
          temperature: "",
          seaArea: "",
          processingPerson: "",
        });
      }
    },
    /**
     * 値を指定してカードを追加する
     * value
     *  name: 名称
     *  expirationDate: 消費期限
     *   temperature: 保存方法
     *   seaArea: 採取海域(数値)
     *   processingPerson: 加工者
     */
    setDestinationLabels(value) {
      let newDestinationLabel = {
        name: value.name,
        expirationDate: value.expirationDate,
        temperature: value.temperature,
        seaArea: value.seaArea || this.seaArea,
        processingPerson: value.processingPerson,
        cardColor: this.setCardColor(value),
        index: this.destinationLabels.length,
      };
      this.destinationLabels.push(newDestinationLabel);
    },
    /**
     * カード追加時のカード色を設定する
     */
    setCardColor(value) {
      if (
        value.name &&
        value.expirationDate &&
        value.temperature !== "" &&
        value.processingPerson !== ""
      ) {
        return CARD_COLOR_NOMAL;
      } else {
        if (this.destinationLabels.length === 0) {
          return CARD_COLOR_ERROR;
        } else {
          return CARD_COLOR_WARNING;
        }
      }
    },
    /**
     * カードを削除する
     */
    async remove(index) {
      if (index < this.destinationLabels.length) {
        await this.destinationLabels.splice(index, 1);
      }

      for (let i = index; i < this.destinationLabels.length; i++) {
        this.destinationLabels[i].index = i;
        // 子コンポーネントでpropsの値を参照し直す
        this.$refs.destination_card_label_child[i].reload();
      }
    },
    /**
     * 採取海域区分を変更する
     */
    changeSeaArea(seaArea) {
      // 親画面の採取海域区分を保持する
      this.seaArea = seaArea;
      for (let i = 0; i < this.destinationLabels.length; i++) {
        this.destinationLabels[i].seaArea = seaArea;
      }
    },
    /**
     * 入力内容が変更された際、値を受け取る
     */
    changeDestinationLabel: function (args, index) {
      this.destinationLabels.splice(index, 1, args);
    },
    /**
     * 出荷先の入力値を返却する
     */
    getDestinationLabels() {
      let res = [];
      for (let i = 0; i < this.destinationLabels.length; i++) {
        let item = {
          name: this.destinationLabels[i].name,
          expirationDate: this.destinationLabels[i].expirationDate,
          temperature: this.destinationLabels[i].temperature,
          processingPerson: this.destinationLabels[i].processingPerson,
        };
        res.push(item);
      }
      return res;
    },
    /**
     * エラーがあればtrueを返す
     */
    hasError() {},
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
}
.card-error {
  background-color: #ffdbe2;
}
.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}
.custom-card-subtitle {
  font-size: 16px;
  line-height: 1.5;
}
.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}
</style>
